<div
    style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 500px; height: 200px; max-width: 100%; max-height: 100%;">
    <div style="min-height: 120px;">
        <img id="loading-icon" src="/assets/img/endoo_profile.png" />
    </div>
</div>
